"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class MetaTagHelper {
    static Get(name, attribute = "content") {
        var item = document.querySelector("meta[name='" + name + "']");
        return item ? item.getAttribute(attribute) : null;
    }
}
exports.default = MetaTagHelper;
